import styled from "styled-components";

export const SkeletonItem = styled.div`
  cursor: default;
  pointer-events: none;
  gap: 12px;
  padding: 8px 4px;
  background: transparent !important;
`;

export const SkeletonThumb = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 6px;

  .placeholder {
    width: 100%;
    height: 100%;
    border-radius: 6px;
    margin: 0;
  }
`;

export const SkeletonText = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;

  .placeholder {
    margin: 0;
    border-radius: 6px;
  }
`;

export const SkeletonLine = styled.span`
  width: 55%;
  height: 12px;
`;
